import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AttritionService {

  private baseUrl = `${environment.apiUrl}/api/attritions`;

  constructor(private http: HttpClient) {}

  getAttritions(perPage: number = 15, year?: number, page: number = 1, search?: string): Observable<any> {
    let params = new HttpParams().set('per_page', perPage).set('page', page);
    if (year) {
      params = params.set('year', year);
    }
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get<any>(this.baseUrl, { params });
  }

  getAttritionById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${id}`);
  }

  updateAttrition(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/${id}`, data);
  }

  retentionData(params?: any): Observable<any> {
    const url = `${environment.apiUrl}/api/retention-data`;
    return this.http.get<any>(url, { params });
  }
}
